<template>
  <line-overflow-temp
      :key="keyNum"
      :content="content"
      :max-lines="maxLines"
      :width="width"
  />
</template>


<script>


import LineOverflowTemp from "@/components/base/layout/text/LineOverflowTemp.vue";

export default {
  name: "LineOverflow",
  components: {LineOverflowTemp},
  // 组件名称
  // 组件方法，引入两个自定义函数
  props: { // 定义组件接收的props
    content: { // 文本内容，非必需
      type: String,
      required: false
    },
    maxLines: { // 最大行数，默认为2
      type: Number,
      default: 2
    },
    width: Number, // 文本容器宽度
  },

  data() {
    return {
      keyNum: 0
    };
  },

  created() {
    this.keyNum++;
  },
  watch: {
    content() {
      this.keyNum++;
    },
    maxLines() {
      this.keyNum++;
    },
    width() {
      this.keyNum++;
    },
  },

};
</script>


<style scoped>
</style>
